import type { ComponentProps } from "react"

import { RefreshCw } from "lucide-react"

import { Button } from "@/components/button"
import { cn } from "@/lib/utils"

export function RefreshButton({
  isFetching,
  onClick,
  className,
  variant = "ghost",
  size = "sm",
}: {
  isFetching: boolean
  onClick: () => void
  className?: string
  variant?: ComponentProps<typeof Button>["variant"]
  size?: ComponentProps<typeof Button>["size"]
}) {
  return (
    <Button
      type="button"
      variant={variant}
      size={size}
      className={cn("gap-1.5", className)}
      onClick={onClick}
      disabled={isFetching}
    >
      <RefreshCw className={cn("size-3.5", isFetching && "animate-spin")} />
      Refresh
    </Button>
  )
}
